import Fetch from "./index";

export const getCatalogIntegration = async (assistantID) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    return Fetch("/assistant/" + assistantID + "/catalog")
}

export const createCatalogIntegration = async (assistantID, body) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    const data = new FormData();
    for (const key in body) {
        data.set(key, body[key]);
    }

    return Fetch(
        "/assistant/" + assistantID + '/catalog/',
        {
            method: 'POST',
            body: data,
        },
    )
}

export const deleteCatalogIntegration = async (assistantID, id) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    return Fetch(
        "/assistant/" + assistantID + '/catalog/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const updateCatalogIntegration = async (assistantID, id, body) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    delete body['createdAt']
    delete body['updatedAt']
    delete body['deletedAt']
    delete body['id']

    const data = new FormData();
    for (const key in body) {
        data.set(key, body[key]);
    }

    return Fetch(
        "/assistant/" + assistantID + '/catalog/' + id,
        {
            method: 'PUT',
            body: data,
        },
    )
}
